import { toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { Button, Tfoot, Tr, Td, Center, IconButton } from '@chakra-ui/react';
import { i18n } from '../../../i18n/translate.js';
import { Pagination } from '../Pagination/component.js';
import { Icon } from '../Icon/component.js';

var TablePaginationFooter = function TablePaginationFooter(_ref) {
  var table = _ref.table,
      data = _ref.data,
      columnCount = _ref.columnCount,
      onPageChange = _ref.onPageChange,
      pagingInfo = _ref.pagingInfo,
      activePageState = _ref.activePageState;
  var pageCount = table.getPageCount();
  var pagination = table.getState().pagination;
  var rowCount = table.getRowCount();
  var currPage = table.getState().pagination.pageIndex;
  var activePage = activePageState && activePageState > 0 ? activePageState : 1;
  var paginationLinks = useMemo(function () {
    return _toConsumableArray(Array(pageCount).keys()).map(function (page) {
      return /*#__PURE__*/React.createElement(Button, {
        key: "core-table-page-btn-".concat(page),
        onClick: function onClick() {
          return table.setPageIndex(page);
        },
        isActive: currPage === page,
        variant: "outline",
        colorScheme: "gray",
        _hover: {
          bg: '#EBEDF0'
        },
        "aria-label": page.toString()
      }, page + 1);
    });
  }, [pageCount, currPage]);
  return /*#__PURE__*/React.createElement(Tfoot, {
    "data-object-type": "pagination"
  }, /*#__PURE__*/React.createElement(Tr, null, /*#__PURE__*/React.createElement(Td, {
    colSpan: columnCount
  }, /*#__PURE__*/React.createElement(Center, {
    gap: 4
  }, pagingInfo || rowCount > data.length ? /*#__PURE__*/React.createElement(Pagination, {
    data: data,
    activePage: activePage,
    pageSize: pagination.pageSize,
    totalCount: rowCount,
    onPageChange: onPageChange,
    coreTable: true
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      return table.previousPage();
    },
    disabled: !table.getCanPreviousPage(),
    icon: /*#__PURE__*/React.createElement(Icon, {
      prefix: "fas",
      iconName: "arrow-left"
    }),
    "aria-label": i18n.t('Previous'),
    bg: "none",
    border: "none",
    variant: "customIconButton",
    _hover: {
      bg: '#EBEDF0'
    }
  }), paginationLinks, /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      return table.setPageIndex(1);
    },
    disabled: !table.getCanNextPage(),
    icon: /*#__PURE__*/React.createElement(Icon, {
      prefix: "fas",
      iconName: "arrow-right"
    }),
    "aria-label": i18n.t('Next'),
    bg: "none",
    border: "none",
    variant: "customIconButton",
    _hover: {
      bg: '#EBEDF0'
    }
  }))))));
};

TablePaginationFooter.displayName = "TablePaginationFooter";
export { TablePaginationFooter };